import { render, staticRenderFns } from "./AdminManagement.vue?vue&type=template&id=039991c4&scoped=true&"
import script from "./AdminManagement.vue?vue&type=script&lang=js&"
export * from "./AdminManagement.vue?vue&type=script&lang=js&"
import style0 from "./AdminManagement.vue?vue&type=style&index=0&id=039991c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039991c4",
  null
  
)

export default component.exports